.company-container {
    display: flex;
}

.company-container > *:last-child {
    flex-grow: 1;
}
